"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileModel = function () {
  function FileModel(data) {
    _classCallCheck(this, FileModel);

    this.values = {
      id: null,
      contents: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(FileModel, [{
    key: "getTitle",
    value: function getTitle() {
      return this.values.id;
    }
  }, {
    key: "getSubtitle",
    value: function getSubtitle() {
      return this.values.contents.length;
    }
  }, {
    key: "getImage",
    value: function getImage() {
      return null;
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      if (this.getCompareString()) {
        return this.getCompareString().substring(0, 1).toUpperCase();
      }

      return null;
    }
  }, {
    key: "getCompareString",
    value: function getCompareString() {
      return this.values.id;
    }
  }, {
    key: "getJSON",
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return FileModel;
}();

exports.default = FileModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/file/model/FileModel.js
// module id = 14
// module chunks = 0